import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials so the httpOnly auth cookie is sent with every request.
// Longer timeout so a single slow cold-start request doesn't fail prematurely.
export const api = axios.create({ baseURL: API, timeout: 45000, withCredentials: true });

// ---- Cold-start resilience ----------------------------------------------
// On production the backend can scale to zero and "sleep" when idle. While it
// wakes up, the gateway returns 502/503/504 or the request times out. These
// failures mean the request never reached the app, so retrying is safe. We
// retry critical calls automatically with exponential backoff + jitter so a
// booking (with discounts, address checking, and time slots) always goes
// through even if the server was asleep.
const MAX_RETRIES = 6;
const RETRYABLE_STATUS = [502, 503, 504];

const isRetryable = (error) => {
  const method = (error.config?.method || "get").toLowerCase();
  const idempotent = method === "get" || method === "head";
  // Network error / timeout: only safe to retry reads (a POST may have been processed).
  if (!error.response) return idempotent;
  // Gateway 5xx: the request never reached the app, so retrying is safe for any method.
  return RETRYABLE_STATUS.includes(error.response.status);
};

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error.config;
    if (!config || !isRetryable(error)) return Promise.reject(error);

    config.__retryCount = config.__retryCount || 0;
    if (config.__retryCount >= MAX_RETRIES) return Promise.reject(error);
    config.__retryCount += 1;

    const base = Math.min(800 * 2 ** (config.__retryCount - 1), 8000);
    const delay = base + Math.random() * 400;
    await new Promise((r) => setTimeout(r, delay));
    return api(config);
  }
);

// Ping the backend so it starts waking up the moment someone lands on the site.
export const wakeServer = async () => {
  for (let i = 0; i < 8; i++) {
    try {
      await axios.get(`${API}/health`, { timeout: 15000 });
      return;
    } catch {
      await new Promise((r) => setTimeout(r, 2000));
    }
  }
};

export const LOGO = "https://customer-assets-39nsmqrw.emergentagent.net/job_pink-crew-oahu/artifacts/xsij2jie_IMG_1859.jpeg";
export const VENMO_QR = "https://customer-assets-39nsmqrw.emergentagent.net/job_pink-crew-oahu/artifacts/d2la3rkk_IMG_2006.jpeg";
export const VENMO_HANDLE = "@aiden289044";
export const VENMO_URL = "https://venmo.com/u/aiden289044";
export const PHONE = "206-602-7035";
